import { DateTime } from 'luxon';

const DateStamp = ({ event }) => {
  const time = DateTime.fromISO(event.datetime, { setZone: true });
  const now = DateTime.local().setZone(time.zoneName);

  const isToday = time.toISODate() === now.toISODate();
  const isTomorrow = time.toISODate() === now.plus({ days: 1 }).toISODate();

  const renderStamp = () => {
    if (isToday) {
      return <span className="text-xs font-semibold">Today</span>;
    }
    if (event.isOnNow) {
      return (
        <div className="text-xs font-semibold">
          <span>On Now</span>
        </div>
      );
    }
    return (
      <span className="text-xs font-semibold">
        {time.toFormat('LLL')} {time.toFormat('d')}
      </span>
    );
  };

  return (
    <div className="rounded-br bg-gray-900 text-white w-14 h-4 align-middle p-0 pb-0 text-center">
      <div className="text-center">{renderStamp()}</div>
    </div>
  );
};

export default DateStamp;
